import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, post, put } from "helpers/api_helper"
import {
  CREATE_TRIAL_OPERATION,
  UPDATE_TRIAL_OPERATION,
  DELETE_TRIAL_OPERATION,
  TRIAL_OPERATION_INVITE_CANDIDATES,
  DELETE_CATERING,
  GET_TRAINING_SCHEDULE,
  GET_TRIAL_OPERATION_MATCHED_CANDIDATES_LIST,
  UPDATE_COMMON_SETTINGS,
  TRIAL_OPERATION_INVITE_CANDIDATES_IMPORT,
  GET_TRIAL_OPERATION_DETAILS,
  GET_ALL_TRIAL_OPERATIONS_ATTENDANCE_LIST,
  GET_ALL_TRIAL_OPERATIONS_ENROLLMENT_LIST,
  EDIT_TRIAL_PERIOD_ATTENDANCE,
  GET_ALL_TRIAL_OPERATIONS_REASON_LIST,
  TRIAL_OPERATION_CAPTURE_ABSENT,
  GET_ALL_TRIAL_OPERATIONS_INSPECTION_LIST,
  DELETE_TRIAL_OPERATION_INSPECTION,
  MARK_TRIAL_OPERATION_INSPECTION_ATTENDANCE,
  GET_ATTENDANCE_LIST,
  MARK_ROASTER_ATTENDANCE,
  UPLOAD_ROASTER_FILE,
  GET_ROASTER_CATERING,
  GET_SCHEDULE_LIST,
  GET_ROASTER_RANDOM_CHECK_LIST,
  MARK_ROASTER_RANDOM_CHECK,
  MARK_ROASTER_ABSENT,
  DELETE_RANDOM_CHECK,
  DELETE_WORK_SCHEDULE,
  GET_ROASTER_SCHEDULE_DETAIL,
  EDIT_ROASTER_ATTENDANCE,
} from "helpers/url_helper"

export const getScheduleList = createAsyncThunk(
  GET_SCHEDULE_LIST,
  async payload => {
    const response = await post(GET_SCHEDULE_LIST, payload)
    return response
  }
)

export const getAttendaceList = createAsyncThunk(
  GET_ATTENDANCE_LIST,
  async payload => {
    const response = await post(GET_ATTENDANCE_LIST, payload)
    return response
  }
)

export const markRoasterAttendance = createAsyncThunk(
  MARK_ROASTER_ATTENDANCE,
  async payload => {
    const response = await post(MARK_ROASTER_ATTENDANCE, payload)
    return response
  }
)

export const getRoasterRandomCheckList = createAsyncThunk(
  GET_ROASTER_RANDOM_CHECK_LIST,
  async payload => {
    const response = await post(GET_ROASTER_RANDOM_CHECK_LIST, payload)
    return response
  }
)

export const importRoasterAttendance = createAsyncThunk(
  UPLOAD_ROASTER_FILE,
  async payload => {
    const response = await formDataPost(UPLOAD_ROASTER_FILE, payload)
    return response
  }
)

export const captureRandomAttendance = createAsyncThunk(
  MARK_ROASTER_RANDOM_CHECK,
  async payload => {
    const response = await formDataPost(MARK_ROASTER_RANDOM_CHECK, payload)
    return response
  }
)
export const captureRandomAbsent = createAsyncThunk(
  MARK_ROASTER_ABSENT,
  async payload => {
    const response = await formDataPost(MARK_ROASTER_ABSENT, payload)
    return response
  }
)

export const getTrialOperationDetails = createAsyncThunk(
  GET_TRIAL_OPERATION_DETAILS,
  async uuid => {
    const response = await get(`${GET_TRIAL_OPERATION_DETAILS}${uuid}`)
    return response
  }
)

export const deleteRandomCheck = createAsyncThunk(
  DELETE_RANDOM_CHECK,
  async id => {
    const response = await del(`${DELETE_RANDOM_CHECK}/${id}`)
    return response
  }
)
export const deleteRoasterSchedule = createAsyncThunk(
  DELETE_WORK_SCHEDULE,
  async id => {
    const response = await del(`${DELETE_WORK_SCHEDULE}/${id}`)
    return response
  }
)

export const getRoasterScheduleDetail = createAsyncThunk(
  GET_ROASTER_SCHEDULE_DETAIL,
  async id => {
    const response = await get(`${GET_ROASTER_SCHEDULE_DETAIL}/${id}`)
    return response
  }
)

export const editRoasterAttendance = createAsyncThunk(
  EDIT_ROASTER_ATTENDANCE,
  async id => {
    const response = await get(`${EDIT_ROASTER_ATTENDANCE}/${id}`)
    return response
  }
)

export const getCateringList = createAsyncThunk(
  GET_ROASTER_CATERING,
  async payload => {
    const response = await post(GET_ROASTER_CATERING, payload)
    return response
  }
)

export const deleteCatering = createAsyncThunk(
  DELETE_CATERING,
  async payload => {
    const response = await del(`${DELETE_CATERING}/${payload}`)
    return response
  }
)
